// Guarda esto como Icons.js para importar los iconos (usa solo los que necesites)
export const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6"><path d="M3 11.5L12 4l9 7.5V20a2 2 0 0 1-2 2h-3v-5H8v5H5a2 2 0 0 1-2-2V11.5z" stroke="currentColor" strokeWidth="2"/></svg>
);
export const CollectionIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6"><rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 3v4M8 3v4M3 11h18" stroke="currentColor" strokeWidth="2"/></svg>
);
export const CampaignIcon = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M8 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
);
export const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6"><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" strokeWidth="2"/><path d="M7 11l5 5 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
);
export const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6"><path d="M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M12 19v2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2"/></svg>
);
